import React from 'react';
import { Link } from 'react-router-dom';

export function LessonPolicies() {
  return (
    <main className="stub stub--doc">
      <Link to="/" className="stub__back">← Back to home</Link>
      <h2>Lesson Policies</h2>
      <p>
        A few shared expectations keep the studio running smoothly and protect
        both of our time. Nothing here is meant to be rigid — life happens, and I
        try to be reasonable — but knowing the ground rules up front means we can
        spend our lessons on the music.
      </p>

      <h3>Scheduling &amp; commitment</h3>
      <p>
        Lessons are booked as a standing weekly slot — the same day and time each
        week — so the hour is reserved for you and practice has a rhythm to settle
        into. New students begin with a single interview lesson before we commit to
        an ongoing schedule, so we can both be sure it's the right fit. Lessons are
        offered in 30, 45, and 60-minute lengths; I'll recommend a length based on
        the student's age and goals.
      </p>

      <h3>Cancellations &amp; makeups</h3>
      <p>
        If you need to cancel, please give me at least <strong>24 hours' notice</strong>.
        With that notice I'll offer <strong>one makeup lesson per term</strong>,
        scheduled at a mutually convenient time (or, when it's easier, held over
        video). Lessons cancelled with less than 24 hours' notice, and missed
        lessons without notice, are charged in full — the slot has been held for
        you and usually can't be re-filled on short notice. If <em>I</em> ever have
        to cancel, that lesson is always made up or credited.
      </p>

      <h3>Payment &amp; billing</h3>
      <p>
        Tuition is invoiced <strong>monthly, in advance</strong>, and is due by the
        first lesson of the month. Payment can be made online or in person; the
        methods I accept are listed on the{' '}
        <Link to="/pay">Payments</Link> page. A month with five lessons is billed
        for five; a month with four is billed for four — you only ever pay for the
        lessons on the calendar.
      </p>

      <h3>Breaks &amp; holidays</h3>
      <p>
        The studio observes major holidays and takes a short break in late December
        and a longer pause in summer; specific dates are shared well in advance and
        aren't billed. Summer scheduling is more flexible — some students continue
        weekly, others switch to a lighter or project-based schedule — and we'll
        plan yours together before the school year ends.
      </p>

      <h3>Practice &amp; materials</h3>
      <p>
        Steady practice between lessons is where the real progress happens; I'll
        always leave you with a clear, achievable plan for the week rather than a
        vague "practice more." Students are responsible for their own instrument in
        good playing condition, plus sheet music and method books as we go — I'll
        tell you what to buy before you need it, and can help with rental
        recommendations for younger or newer players.
      </p>

      <h3>Communication</h3>
      <p>
        Reach me by email for scheduling changes, questions, or anything that comes
        up between lessons. For students under 18, a parent or guardian is welcome
        at lessons and will be kept in the loop on progress and goals.
      </p>

      <p style={{ marginTop: 40 }}>
        <Link to="/schedule" className="btn btn--primary">Schedule a lesson →</Link>
      </p>
    </main>
  );
}
